export default {
    watch: {
        word(val) {
            if (val) {
                this.$router.push({
                    name: 'word'
                })
            }
        },
        examEndMata(val) {
            val ? this.$router.push({
                name: 'examend'
            }) : ''
        }
    }
}



// WEBPACK FOOTER //
// ./src/controller/goAnWordController.js